import { AfterViewInit, PLATFORM_ID, Component, ElementRef, Inject, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { PartnerGroup } from '../../../models/partner-group';
import { PartnerService } from '../../../services/partner.service';
import { AddPartnerToGroupModalComponent } from '../../_modals/add-partner-to-group-modal/add-partner-to-group-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { PartnerGroupMember } from 'src/app/shared/models/partner-group-member';
import { ActivatedRoute } from '@angular/router';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { AddPostDilutorModalComponent } from '../../_modals/add-post-dilutor-modal/add-post-dilutor-modal.component';
import { Subject, Subscription, timer } from 'rxjs';
import { debounce, debounceTime, groupBy, mergeMap, timeout } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-partner-group-management',
  templateUrl: './partner-group-management.component.html',
  styleUrls: ['./partner-group-management.component.scss']
})
export class PartnerGroupManagementComponent implements OnInit, AfterViewInit, OnDestroy {

  mibeId: number | null = null;

  isImportingGroups = false;

  @ViewChild(MatSort) sort: MatSort;
  currentSortColumn: string | null = null;
  currentSortDirection: string | null = null;

  // @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatTable) table: MatTable<any>;

  displayedColumns = ['members', 'totalAllocationPercentage', 'action']

  // need reference to old allocation values
  oldPartnerGroups: any[];
  prevPartnerGroups;
  partnerGroups: PartnerGroup[] = [];

  displayValues: any[] = [];

  showExpandedDetailsRow: boolean = false;
  element: any;

  partnerGroupId: number | null;

  dragMember: PartnerGroupMember;
  // dropMember: any;

  private subs: Subscription[] = [];

  // allocation percentage edits wait here until their field has gone 500 ms without a keystroke
  private percentageChanges = new Subject<{ value: number, element: any, member: PartnerGroupMember }>();

  private isBrowser: boolean = false;

  private isPercentageSpinnerDown = false;
  private percentSpinnerUp = new Subject<void>();

  constructor(private partnerService: PartnerService, public dialog: MatDialog, private snackbarService: SnackBarService, private route: ActivatedRoute, @Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {

    // debounced per member, so moving to another field within 500 ms doesn't drop the first edit
    this.subs.push(this.percentageChanges.pipe(
      groupBy(change => change.member),
      mergeMap(changes => changes.pipe(debounce((value) => this.isPercentageSpinnerDown ? this.percentSpinnerUp : timer(500))))
    ).subscribe(change => this.verifyPercentages(change.value, change.element, change.member, change.member.allocationPercentage)));

    this.route.paramMap.subscribe(params => {
      const idParam = params.get('partnerGroupId');
      this.partnerGroupId = idParam ? +idParam : null;
      // expands details if not null
    });

    this.partnerService.getPartnerGroups().subscribe(x => {


      this.partnerService.setPartnerGroups(x);
    });

    this.partnerService.partnerGroups$.subscribe(x => {
      // need a reference to old partnerGroupValues
      // grabs initial value, this.oldPartnerGroups value is changed following each onChange event (amount verification method)
      // if (this.oldPartnerGroups) {
      //   this.oldPartnerGroups = this.partnerGroups;
      // } else 
      if (!this.oldPartnerGroups) {
        this.oldPartnerGroups = x;
      }
      this.partnerGroups = x;
      this.mibeId = this.findMibeId(this.partnerGroups);

      this.displayValues = []; //reset

      this.partnerGroups.forEach(group => {

        let totalAllocationPercentage = group.members.reduce((total, member) => total + member.allocationPercentage, 0);

        // let name = '';
        // group.members.forEach(member => {
        //   name += member.partner.name + '+';
        // });

        let displayObject = {
          members: this.moveMibeToTop(group.members, this.mibeId),
          totalAllocationPercentage: totalAllocationPercentage,
          exportDilutedValue: false,
          group: group,
          expandDetails: false
        };

        //compare against this.partnerGroupId
        if (this.partnerGroupId) {
          if (this.partnerGroupId == group.id) {
            //we have a match, show the details
            //TODO: need to auto focus on the html element (scroll to if necessary)
            displayObject.expandDetails = true;
          }
        }

        this.displayValues.push(displayObject);
      })

      this.dataSource = new MatTableDataSource(this.displayValues);

      //EXAMPLE OF CUSTOMIZED SORTING FOR TABLE
      //CUSTOM SORTING BELOW IS NOT WORKING CORRECTLY

      //provide custom sorting for proStatus column
      // this.dataSource.sortingDataAccessor = (item, property) => {
      //   switch (property) {
      //     case 'proStatus':
      //       let index = PRO_STATUS_ORDER[item.proStatus] ?? -1;
      //       return index;
      //     default:
      //       return item[property] ?? '';
      //   }
      // };

      //this.dataSource.sort = this.sort;

      this.subs.push(this.partnerService.startImport$.subscribe(res => {
        this.isImportingGroups = true;
      }));

      this.subs.push(this.partnerService.doneImporting$.subscribe(res => {
        this.isImportingGroups = false;
        this.snackbarService.showSnackBarMessage('Import finished successfully', 'Close', 2000);

        this.partnerService.getPartnerGroups().subscribe(x => {
          this.partnerService.setPartnerGroups(x);
        });
      }, ex => {
        this.isImportingGroups = false;
        this.snackbarService.showSnackBarMessage('Error importing groups', 'Close', 2000);
      }));
    });

  }

  onPercentageMousedown(e: MouseEvent) {
    if (this.isBrowser) {
      let elm = e.target as HTMLElement;

      // if mousedown on number spinner
      if (e.offsetX > elm.clientWidth - 16) {
        const mouseup = () => {
          this.isPercentageSpinnerDown = false;
          this.percentSpinnerUp.next();
          document.removeEventListener('mouseup', mouseup);
        }

        this.isPercentageSpinnerDown = true;
        document.addEventListener('mouseup', mouseup);
      }
    }
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.currentSortColumn = sort.active;
      this.currentSortDirection = sort.direction;

      if (sort.active === 'members') {
        this.sortByGroup(sort.direction);
      }
    });

    this.dataSource.sort = this.sort;

    if (this.partnerGroupId) {
      // Ensure the view has fully initialized before attempting to scroll
      setTimeout(() => {
        const targetRow = document.getElementById(this.partnerGroupId.toString());

        if (targetRow) {
          targetRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100); // Timeout to ensure Angular's change detection has completed
    }
  }

  ngOnDestroy() {
    this.subs.forEach(x => x.unsubscribe());
  }

  /**
   * Returns Mibe Music's partner id, or null if no group has Mibe Music as a member.
   * Looked up by name because the id is not the same in every database.
   * @param groups 
   * @returns 
   */
  findMibeId(groups: PartnerGroup[]): number | null {
    for (const group of groups) {
      const mibe = group.members.find(member => member.partner.name.toLowerCase() === 'mibe music');
      if (mibe) {
        return mibe.partner.id;
      }
    }
    return null;
  }

  /**
   * Places Mibe Music at the top of each group members list
   * @param members 
   * @param id 
   * @returns 
   */
  moveMibeToTop(members: any[], id: number) {
    const memberToMove = members.find(member => member.partner.id === id);
    const otherMembers = members.filter(member => member.partner.id !== id);

    if (memberToMove) {
      return [memberToMove, ...otherMembers];
    } else {
      return members; // Return original array if the member is not found
    }
  }

  /**
   * returns the summed total percentage for all group members
   * pretty sure this should alway sbe 100
   * @param group 
   * @returns 
   */
  getTotalAllocationPercentage(group: PartnerGroup): number {
    let total: number = 0;
    group.members.forEach(member => {
      if (member.postDilution != true) {
        total += member.allocationPercentage;
      }
    });
    // return .members.reduce((total, member) => total + member.allocationPercentage, 0);
    // rounded so two-decimal percentages that add up to 100 compare equal to 100
    return Math.round(total * 100) / 100;
  }


  addPartnerToGroup(group: PartnerGroup) {
    //open modal for adding a new partner
    const dialogRef = this.dialog.open(AddPartnerToGroupModalComponent, {
      // width: '800px',
      // height: '400px',
      data: { partnerGroup: group } // If you need to pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');

      this.partnerService.getPartnerGroups().subscribe((x) => {
        this.partnerService.setPartnerGroups(x);
      });

    });
  }

  /**
   * Returns the group name (partner names with '+' symbols)
   * Used for tooltip
   * @param element 
   * @returns 
   */
  getGroupDisplayName(element: any): string {
    // return element.members.map((member: any) => member.partner.name).join(' + ');
    return element.group.name;
  }


  /**
   * Called when the drop down arrow is selected
   * Shows or hides group details
   * @param element 
   */
  toggleDetails(element: any) {

    element.expandDetails = !element.expandDetails;

    console.log(element.expandDetails)

  }


  /**
   * Used with ngClass to modify UI styling when a row's
   * expandedDetails are show
   * @param element 
   * @returns 
   */
  styleExpandedDetailsRow(element: any): boolean {

    //test hidden
    return element.expandDetails;
  }


  /**
   * Call this method to automatically save changes
   * on any data updates
   */
  updatePartnerGroup(element: any) {
    this.partnerService.updatePartnerGroup(element.group).subscribe(
      (resPartnerGroup) => {
        //this.partnerService.getPartnerGroups().subscribe(x => {
        //  this.partnerService.setPartnerGroups(x);
        element.group = resPartnerGroup;
        // the expanded member rows and the table's group list have to point at the new objects too,
        // or later edits in this group change objects that are no longer the ones saved
        element.members = this.moveMibeToTop(resPartnerGroup.members, this.mibeId);
        this.partnerGroups = this.partnerGroups.map(g => g.id === resPartnerGroup.id ? resPartnerGroup : g);
        //log success message
        this.snackbarService.showSnackBarMessage("Changes saved!", "Closed");
        //});
      },
      (error) => {
        this.snackbarService.showSnackBarMessage("An error occurred. Your changes may not have saved.", "Closed", undefined, true);
      })
  }

  updatePartnerGroupMember(member: PartnerGroupMember) {
    this.partnerService.updatePartnerGroupMember(member).subscribe(
      (resPartnerGroupMember) => {
        this.snackbarService.showSnackBarMessage("Changes saved!", "Close");
      },
      (error) => {
        this.snackbarService.showSnackBarMessage("An error occurred, your changes may not have saved.", "Close", undefined, true);
      }
    )
  }

  /**
   * Queues a percentage field's new value. verifyPercentages runs once the field has gone 500 ms without a keystroke.
   * The model is left alone until then, so verifyPercentages still receives the old percentage.
   * @param value
   * @param element
   * @param member
   */
  onPercentageChange(value: number, element: any, member: PartnerGroupMember) {
    this.percentageChanges.next({ value, element, member });
  }

  /**
   * Ensures percentage is not less than 0% and does not collectively exceed 100%
   * @param event 
   * @param element 
   * @param member 
   */
  verifyPercentages(event: any, element: any, member: any, oldAllocationPercentage: any) {

    const newAllocationPercentage = event;
    // Graham W, 2/6/25
    // half-implementing a 'master partner' to add or remove any % amount when a change is made to another partner
    // ie, taking 20% off a partner will immediately add 20% to the 'master partner' in addition to a pop-up notification

    // currently needs to capture the previous amount so the difference can be calculated

    const masterPartnerName = 'mibe music';

    if (!member.postDilution) {
      const difference = newAllocationPercentage - oldAllocationPercentage;
      // const difference = 0;
      if (member.partner.name.toLowerCase() != masterPartnerName) {
        // const difference = oldPartner.allocationPercentage - member.allocationPercentage;
        var masterPartner_inGroup = element.group.members.find(m => m.partner.name.toLowerCase() == masterPartnerName);

        // update master partner 
        // rounded to the 2 decimals the backend stores, or float error shows as e.g. 41.699999999999996
        masterPartner_inGroup.allocationPercentage = Math.round((masterPartner_inGroup.allocationPercentage - difference) * 100) / 100;
      }
      else {

        // m_new = m_old × (100 − N) / S        where S = sum of the other members' current percentages

        const others = element.group.members.filter((m: PartnerGroupMember) => m !== member && !m.postDilution);
        const othersTotal = others.reduce((total: number, m: PartnerGroupMember) => total + m.allocationPercentage, 0);
        const remaining = 100 - newAllocationPercentage;

        // work in hundredths, the 2 decimals the backend stores
        let assigned = 0;
        others.forEach((m: PartnerGroupMember) => {
          const share = othersTotal > 0 ? m.allocationPercentage / othersTotal : 1 / others.length;
          const hundredths = Math.round(share * remaining * 100);
          m.allocationPercentage = hundredths / 100;
          assigned += hundredths;
        });

        // rounding can leave a cent over or under; give it to the largest member
        const leftover = Math.round(remaining * 100) - assigned;
        if (leftover !== 0 && others.length > 0) {
          const largest = others.reduce((a: PartnerGroupMember, b: PartnerGroupMember) => b.allocationPercentage > a.allocationPercentage ? b : a);
          largest.allocationPercentage = (Math.round(largest.allocationPercentage * 100) + leftover) / 100;
        }
      }

      member.allocationPercentage = newAllocationPercentage;
      // const prevPartnerGroups = this.dataSource.data.map(g => g.group);
      // this.oldPartnerGroups = prevPartnerGroups;
      var totalPercent = this.getTotalAllocationPercentage(element.group);
      // if (totalPercent != 100) {
      //   const addToMaster = 100 - totalPercent;
      //   masterPartner_inGroup.allocationPercentage -= addToMaster;  
      // }

      if (totalPercent > 100) {
        // calculate percent change
        this.snackbarService.showSnackBarMessage("Adjusted master partner 'MIBE Music' allocation.", "Close", undefined, true);
        // this.snackbarService.showSnackBarMessage("Total allocation percentage for partner group exceeds 100%. Adjustments needed.", "Close", undefined, true);
      }
      else if (totalPercent < 100) {
        this.snackbarService.showSnackBarMessage("Adjusted master partner 'MIBE Music' allocation.", "Close", undefined, true);
        // this.snackbarService.showSnackBarMessage("Total allocation percentage for partner group does not equate to 100%. Adjustments needed.", "Close", undefined, true);
      }
      else if (totalPercent == 100) {
        this.snackbarService.showSnackBarMessage("Total allocation percentage for partner group is 100%.", "Close");

        this.partnerService.updatePartnerGroup(element.group).subscribe(res => {
          this.snackbarService.showSnackBarMessage("Changes saved!", "Close");
        })
      }
    }

    else {

      // let percent = parseInt((event.target as HTMLInputElement).value);
      let percent = event;

      if (percent > 100) {
        this.snackbarService.showSnackBarMessage("Total allocation percentage for post dilution member exceeds 100%. Adjustments needed.", "Close", undefined, true);
      }
      else if (percent < 0) {
        this.snackbarService.showSnackBarMessage("Total allocation percentage for post dilution member cannot be less than 0%. Adjustments needed.", "Close", undefined, true);
      }
      else {
        this.partnerService.updatePartnerGroup(element.group).subscribe(res => {
          this.snackbarService.showSnackBarMessage("Changes saved!", "Close");
        })
      }
    }
  }

  /**
   * Determines which member is being dragged
   * @param event 
   * @param member 
   */
  onDrag(event: CdkDragDrop<any[]>, member: PartnerGroupMember) {
    //track which member is being dragged
    this.dragMember = member;
  }

  /**
   * Handle re-ordering of members on drop
   * @param event 
   * @param group 
   */
  onDrop(event: CdkDragDrop<any[]>, group: any) {

    const prevIndex = group.members.findIndex((member) => member === this.dragMember);
    this.moveItemInArray(group.members, prevIndex, event.currentIndex);

    //TODO: call save - build in backend config for ordering (implement ordering on FE)
  }

  /**
   * Method to move item in array
   * @param array 
   * @param fromIndex 
   * @param toIndex 
   */
  moveItemInArray(array: any[], fromIndex: number, toIndex: number) {

    if (fromIndex === toIndex) {
      return; // No need to move if indices are the same
    }

    // Ensure the indices are within bounds
    if (fromIndex < 0 || toIndex < 0 || fromIndex >= array.length || toIndex >= array.length) {
      return; // Out of bounds check
    }

    // Swap elements
    const element = array[fromIndex];
    array[fromIndex] = array[toIndex];
    array[toIndex] = element;
  }

  removeMemberFromGroup(member: any, group: any) {

    const confirm = window.confirm("Are you sure you wish to remove this member from the group?")

    if (confirm) {
      const amountRemoved = member.allocationPercentage;
      const masterPartnerName = 'mibe music';

      // a post dilutor's percentage is a share of its parent's, not of the group's 100%,
      // so only a member that counts toward the group total hands its percentage back to Mibe Music
      if (!member.postDilution && member.partner.name.toLowerCase() !== masterPartnerName) {
        // const difference = oldPartner.allocationPercentage - member.allocationPercentage;
        var masterPartner_inGroup = group.group.members.find((m: any) => m.partner.name.toLowerCase() == masterPartnerName);
        // update master partner 
        masterPartner_inGroup.allocationPercentage = Math.round((masterPartner_inGroup.allocationPercentage + amountRemoved) * 100) / 100;
      }

      // The api deletes whichever members are missing from group.group.members, so they have to come out
      // of that list, not just the displayed group.members (a separate array once Mibe Music is moved to
      // the top). Matched by id because a post dilutor row is a separate object from its copy in that list.
      // A member's own post dilutors are removed with it.
      const removedIds = [member.id, ...(member.postDilutionChildren || []).map((child: any) => child.id)];
      group.group.members = group.group.members.filter((m: any) => !removedIds.includes(m.id));
      group.members = group.members.filter((m: any) => !removedIds.includes(m.id));

      const parent = group.group.members.find((m: any) => m.id === member.postDilutionParentId);
      if (parent) {
        parent.postDilutionChildren = parent.postDilutionChildren.filter((child: any) => child.id !== member.id);
      }

      this.updatePartnerGroup(group);
    }

  }


  addPostDilutor(partnerGroupMember: PartnerGroupMember, partnerGroup: any) {
    //open modal for adding a new partner
    const dialogRef = this.dialog.open(AddPostDilutorModalComponent, {
      // width: '800px',
      // height: '400px',
      data: {
        partnerGroupMember: partnerGroupMember,
        partnerGroup: partnerGroup.group
      } // If you need to pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');

      this.partnerService.getPartnerGroups().subscribe((x) => {
        this.partnerService.setPartnerGroups(x);
      });

    });
  }


  //sorts the partner groups alphabetically a-z or z-a, in the direction MatSort reports
  //for the Group header. The api already returns groups a-z, so the direction has to
  //come from the click rather than from reversing whatever order the data is in
  sortByGroup(direction: SortDirection) {
    //a cleared sort ('') goes back to the api's default order, a-z
    this.partnerGroups.sort((a, b) => a.name.localeCompare(b.name));
    if (direction === 'desc') {
      this.partnerGroups.reverse();
    }

    this.partnerService.setPartnerGroups(this.partnerGroups);
  }

  //sorts the partner groups by allocation percentage
  sortByAllocation() {
    // Check to see if the array is already sorted by earningsYTD in ascending order
    const isSorted = this.partnerGroups.every((item, index) => {
      // Ensure that 'Mibe Music' remains at the top
      var ordered =
        index === 0 ||
        this.getTotalAllocationPercentage(item) <= this.getTotalAllocationPercentage(this.partnerGroups[index - 1]);

      return ordered;
    });

    if (isSorted) {
      // Reverse the array if it's already sorted by earningsYTD
      this.partnerGroups.reverse();
    } else {
      // Sort by earningsYTD (ascending order)
      this.partnerGroups.sort((a, b) => this.getTotalAllocationPercentage(b) - this.getTotalAllocationPercentage(a));
    }

    // Update the global partners variable
    this.partnerService.setPartnerGroups(this.partnerGroups);
  }

  getSortDirection(column: string): string | null {
    return this.currentSortColumn === column ? this.currentSortDirection : null;
  }

}
